import { render, staticRenderFns } from "./plain.vue?vue&type=template&id=8c3259d6"
import script from "./plain.vue?vue&type=script&lang=ts"
export * from "./plain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports